export enum BroadcastingSoftware {
    youtube = 'youtube_studio',
    tradersyard = 'tradersyard_live',
}
